import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController, AlertController, ToastController, Content } from 'ionic-angular';
import { HttpFamilyProvider } from '../../../providers/http-family';
import { BasicState } from '../../../states/basic-state';
import { ChildEditPage } from '../../child/edit/child-edit';
import { AbstractPage } from '../../_com/abstract-page';
import Utils from '../../../_com/utils';

/**
 * Generated class for the FamilyEditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-family-edit',
  templateUrl: 'family-edit.html',
})
export class FamilyEditPage extends AbstractPage {

  family = {};
  isUpdate = false;
  @ViewChild(Content) content: Content;

  constructor(
    public navCtrl: NavController, 
    private navParams: NavParams, 
    public modalController:ModalController,
    public viewController:ViewController,
    public alertController:AlertController,
    public toastController:ToastController,
    private httpFamilyProvider:HttpFamilyProvider, 
    private basicState:BasicState,
    private el: ElementRef) {
    super();

    super.readyDomAccess(this.el);
  }

  ionViewDidLoad() {
    if (this.navParams.data.family){
      this.family =  Utils.clone(this.navParams.data.family);
      this.isUpdate = true;
    }
  }

  /**
   * 保存処理
   */
  save(){

    var self = this;

    //必須チェック
    if(this.hasInvalidRequired()){
      this.alert(this.alertController, "未入力の項目を確認してください");
      return;
    }
    
    this.confirm(this.alertController, "入力内容で保存します。よろしいですか？", ()=>{
      for(let index in this.family["children"]){
        this.family["children"][index] = this.family["children"][index]["Child"]["id"];
      }

      this.httpFamilyProvider.save(this.family).subscribe((res) => {

        //登録エラー
        if (res["message"]){
          this.alert(this.alertController, res["message"]);
          return;
        }

        //登録成功
        this.basicState.triggerFamilyDetailRefresh(res.data.family);
        if (this.isUpdate) {
          this.navCtrl.pop();
        } else {
          self.family = res.data.Family;
          this.isUpdate = true;
          this.toast(this.toastController, "登録が完了しましたので、子供の情報を追加できます");
          this.content.scrollToBottom();
        }
      });
    });
  }

  /**
   * 住所更新のinputイベント発火
   */
  eventFireForAddressInput(){
    var Event = document.createEvent('HTMLEvents');
    Event.initEvent('input', true, false );
    document.getElementsByName('address')[0].dispatchEvent(Event);
  }

  /**
   * 子供を追加する
   */
  addChild(){
    this.navCtrl.push(ChildEditPage, {family:this.family});
  }
}


// WEBPACK FOOTER //
// ./src/pages/family/edit/family-edit.ts